import { CableConnectionManager } from './CableConnectionManager'
import { AlmanacCable } from './types'

export class DebugCable implements AlmanacCable {
  constructor(private realThing: CableConnectionManager) {}
  disconnect(): void {
    this.realThing.disconnect()
  }
}
